import React, {
  useContext,
  useEffect,
  useState,
  useMemo,
  Fragment,
} from "react"
//import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import { ViewportContext } from "../contexts/viewport-context"
import { randomBytes } from "crypto"

const InformationTemplate = ({ pageContext }) => {
  const width = useContext(ViewportContext)[0]
  const [lang, setLang] = useState(null)

  useEffect(() => {
    require("@lottiefiles/lottie-player")
    setLang(localStorage.getItem("senses-integration-language"))
  }, [])

  const address = useMemo(() => {
    const berlin = pageContext.address["berlin"].map((val, idx) => {
      if (idx !== pageContext.address["berlin"].length - 1) {
        return (
          <Fragment key={randomBytes(6).toString("hex")}>
            {val}
            <br />
          </Fragment>
        )
      }
      return <Fragment key={randomBytes(6).toString("hex")}>{val}</Fragment>
    })
    const shanghai = pageContext.address["shanghai"].map((val, idx) => {
      if (idx !== pageContext.address["shanghai"].length - 1) {
        return (
          <Fragment key={randomBytes(6).toString("hex")}>
            {val}
            <br />
          </Fragment>
        )
      }
      return <Fragment key={randomBytes(6).toString("hex")}>{val}</Fragment>
    })
    return [shanghai, berlin]
  }, [pageContext.address])

  const telephone = useMemo(() => {
    return pageContext.tel.map((val, idx) => {
      if (idx !== pageContext.tel.length - 1) {
        return (
          <Fragment key={randomBytes(6).toString("hex")}>
            {val}
            <br />
          </Fragment>
        )
      }
      return <Fragment key={randomBytes(6).toString("hex")}>{val}</Fragment>
    })
  }, [pageContext.tel])

  return (
    <Layout path={pageContext.url} width={width} lang={lang ? lang : "de"}>
      <SEO title={`Employee | ${pageContext.name}`} />
      <div className="employee-page flex flex-col sm:flex-row items-center sm:h-screen">
        <section className="w-full sm:w-1/2 h-screen sm:h-screen">
          <lottie-player
            src="/assets/animations/hello_v1.json"
            background="transparent"
            speed="1"
            style={{
              width: width > 640 ? "50vh" : "90vw",
              height: width > 640 ? "50vh" : "58vh",
              maxWidth: width > 640 ? "43vw" : "none",
            }}
            loop
            autoplay
          ></lottie-player>
        </section>
        <section className="w-full sm:w-1/2 h-screen sm:h-screen">
          <h6>HELLO, MY NAME IS</h6>
          <h1>{pageContext.name}</h1>
          <h6 className="font-normal">{address[0]}</h6>
          <h6 className="font-normal">{address[1]}</h6>
          <h6 className="font-normal">
            {telephone}
            <br />
            <a href={`mailto:${pageContext.email}`}>{pageContext.email}</a>
          </h6>
          <aside className="flex flex-col sm:flex-row">
            <button>
              <a href={pageContext.vcard}>DOWNLOAD vCARD</a>
            </button>
            <button>FOLLOW US ON WECHAT</button>
          </aside>
        </section>
      </div>
    </Layout>
  )
}

export default InformationTemplate
